module.exports = __webpack_public_path__ + "static/media/doubleShield.6839991d.jpg";